// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.action-block-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-items: flex-center;
  padding-left: 16px;
  font-family: "Proxima Nova", sans-serif;
}
.action-block-container .status-label {
  border-radius: 5px;
  align-items: center;
  display: flex;
  justify-content: center;
  text-transform: capitalize;
  text-align: center;
  font-size: 10px;
  color: #5F5F5F;
}
.action-block-container .actions {
  display: flex;
  align-items: center;
  column-gap: 8px;
}
.action-block-container .actions > p {
  padding: 4px 8px;
  text-align: center;
  margin: 0;
  border-radius: 6px;
  cursor: pointer;
  transition: 0.2s ease-in-out;
  font-size: 10px;
  font-weight: 700;
  color: white;
  border: 1px solid transparent;
}
.action-block-container .actions > p:hover {
  opacity: 0.75;
}
.action-block-container .actions > p.approve {
  background-color: #02B946;
  border-color: #02B946;
  color: white;
}
.action-block-container .actions > p.feedback, .action-block-container .actions > p.start {
  background-color: var(--primary-color-1);
  border-color: var(--primary-color-1);
  color: white;
}
.action-block-container .actions > p.reject {
  background-color: white;
  border-color: #C9C9C9;
  color: #5F5F5F;
}
.action-block-container .actions > p.error {
  background-color: #EF4546;
  border-color: #EF4546;
  color: white;
}
.action-block-container .actions > p.draft {
  background-color: var(--primary-color-1);
  color: white;
}
.action-block-container .actions > p.disabled {
  pointer-events: none;
}
.action-block-container .actions > p.reshwowing {
  background-color: var(--primary-color-1);
  color: white;
}
.action-block-container .reason-modal {
  opacity: 0;
  visibility: hidden;
  height: 100vh;
  width: 100vw;
  transition: 0.3s ease-in-out;
  position: fixed;
  background: rgba(255, 255, 255, 0.7);
  top: 0;
  left: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.action-block-container .reason-modal.visible {
  opacity: 1;
  visibility: visible;
}
.action-block-container .reason-modal .form-section {
  height: auto;
  width: 640px !important;
  background: #FFFFFF;
  box-shadow: 0px 4px 20px rgba(53, 99, 55, 0.2);
  border-radius: 10px;
  padding: 50px 70px;
  display: flex;
  flex-direction: column;
}
.action-block-container .reason-modal .form-section .section-title {
  margin: 0;
  font-weight: 700;
  font-size: 20px;
  color: var(--secondary-color-1);
}
.action-block-container .reason-modal .form-section .section-title > span {
  font-size: 14px;
  font-weight: 600;
  color: #6C767C;
}
.action-block-container .reason-modal .form-section textarea {
  height: 300px;
}
.action-block-container .reason-modal .form-section > button {
  height: 45px;
  font-size: 16px;
}
.action-block-container .reason-modal .form-section > button.cancel {
  background: var(--secondary-color-4);
  color: var(--secondary-color-3);
}
.action-block-container .reason-modal .form-section > button.cancel:hover {
  opacity: 0.75;
}

@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .action-block-container {
    align-items: flex-end;
    min-height: 50px;
  }
}
@media (min-width: 768px) and (max-width: 1024px), (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .action-block-container .actions {
    flex-wrap: wrap;
    row-gap: 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/AgentDashboard/modules/ManageShowings/modules/ActionBlock/actionBlock.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,wBAAA;EACA,kBAAA;EACA,uCAAA;AADJ;AAEI;EACI,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,0BAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AAAR;AAEI;EACI,aAAA;EACA,mBAAA;EACA,eAAA;AAAR;AACQ;EACI,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,6BAAA;AACZ;AAAY;EACI,aAAA;AAEhB;AAAY;EACI,yBAAA;EACA,qBAAA;EACA,YAAA;AAEhB;AAAY;EACI,wCAAA;EACA,oCAAA;EACA,YAAA;AAEhB;AAAY;EACI,uBAAA;EACA,qBAAA;EACA,cAAA;AAEhB;AAAY;EACI,yBAAA;EACA,qBAAA;EACA,YAAA;AAEhB;AAAY;EACI,wCAAA;EACA,YAAA;AAEhB;AAAY;EACI,oBAAA;AAEhB;AAAY;EACI,wCAAA;EACA,YAAA;AAEhB;AAEI;EACI,UAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;EACA,oCAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAR;AACQ;EACI,UAAA;EACA,mBAAA;AACZ;AACQ;EACI,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,8CAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AACZ;AAAY;EACI,SAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;AAEhB;AADgB;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAGpB;AAAY;EACI,aAAA;AAEhB;AAAY;EACI,YAAA;EACA,eAAA;AAEhB;AADgB;EACI,oCAAA;EACA,+BAAA;AAGpB;AAFoB;EAAU,aAAA;AAK9B;;ACvHY;ED0HR;IACI,qBAAA;IACA,gBAAA;EACN;AACF;ACvHY;ED0HJ;IACI,eAAA;IACA,YAAA;EAAV;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\r\n\r\n.action-block-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    align-items: flex-center;\r\n    padding-left: 16px;\r\n    font-family: 'Proxima Nova', sans-serif;            \r\n    .status-label {\r\n        border-radius: 5px;\r\n        align-items: center;\r\n        display: flex;\r\n        justify-content: center;\r\n        text-transform: capitalize;\r\n        text-align: center;\r\n        font-size: 10px;\r\n        color: #5F5F5F;\r\n    }\r\n    .actions {\r\n        display: flex;\r\n        align-items: center;\r\n        column-gap: 8px;\r\n        > p {\r\n            padding: 4px 8px;\r\n            text-align: center;\r\n            margin: 0;\r\n            border-radius: 6px;\r\n            cursor: pointer;\r\n            transition: .2s ease-in-out;\r\n            font-size: 10px;\r\n            font-weight: 700;\r\n            color: white;\r\n            border: 1px solid transparent;\r\n            &:hover {\r\n                opacity: .75;\r\n            }\r\n            &.approve {\r\n                background-color: #02B946;\r\n                border-color: #02B946;\r\n                color: white;\r\n            }\r\n            &.feedback, &.start {\r\n                background-color: var(--primary-color-1);\r\n                border-color: var(--primary-color-1);\r\n                color: white;\r\n            }\r\n            &.reject {\r\n                background-color: white;\r\n                border-color: #C9C9C9;\r\n                color: #5F5F5F;\r\n            }\r\n            &.error {\r\n                background-color: #EF4546;\r\n                border-color: #EF4546;\r\n                color: white;\r\n            }\r\n            &.draft {\r\n                background-color: var(--primary-color-1);\r\n                color: white;\r\n            }\r\n            &.disabled {\r\n                pointer-events:none;\r\n            }\r\n            &.reshwowing {\r\n                background-color: var(--primary-color-1);\r\n                color: white;\r\n            }\r\n        }\r\n    }                              \r\n    .reason-modal {\r\n        opacity: 0;\r\n        visibility: hidden;\r\n        height: 100vh;\r\n        width: 100vw;\r\n        transition: .3s ease-in-out;\r\n        position: fixed;\r\n        background: rgba($color: #fff, $alpha: .70);\r\n        top: 0;\r\n        left: 0;\r\n        z-index: 999;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        &.visible {\r\n            opacity: 1;\r\n            visibility: visible;\r\n        }\r\n        .form-section {\r\n            height: auto;\r\n            width: 640px !important;\r\n            background: #FFFFFF;\r\n            box-shadow: 0px 4px 20px rgba(53, 99, 55, 0.2);\r\n            border-radius: 10px;\r\n            padding: 50px 70px;\r\n            display: flex;\r\n            flex-direction: column;\r\n            .section-title {\r\n                margin: 0;\r\n                font-weight: 700;\r\n                font-size: 20px;\r\n                color: var(--secondary-color-1);\r\n                > span {\r\n                    font-size: 14px;\r\n                    font-weight: 600;\r\n                    color: #6C767C;\r\n                }\r\n            }\r\n            textarea {\r\n                height: 300px;\r\n            }\r\n            > button {\r\n                height: 45px;\r\n                font-size: 16px;\r\n                &.cancel {\r\n                    background: var(--secondary-color-4);\r\n                    color: var(--secondary-color-3);\r\n                    &:hover { opacity: .75; }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@include media(mobile) {\r\n    .action-block-container {\r\n        align-items: flex-end;\r\n        min-height: 50px;\r\n    }\r\n}\r\n@include media(tablet) {\r\n    .action-block-container {\r\n        .actions {\r\n            flex-wrap: wrap;\r\n            row-gap: 8px;\r\n        }\r\n    }\r\n}","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
